import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=491937d1&scoped=true"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"
import style0 from "./mail.vue?vue&type=style&index=0&id=491937d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491937d1",
  null
  
)

export default component.exports